import { DataBean } from "../DataBean";

export class BackupTypeSelect extends DataBean {



    public async getDocumentBackupTypes(id:any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_getDocumentBackupTypes_Number", [id]);
    }
}